var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"avp-contact-link",attrs:{"href":_vm.emailLink}},[_vm._v(_vm._s(_vm.$t('generic.support.email')))])}
var staticRenderFns = []

export { render, staticRenderFns }